import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { Modal, Button, Form, message, Input, Typography } from "antd";

import { projectSubgraphsPath } from "../../helpers/paths";
import { CREATE_PROJECT_MUTATION, PROJECTS_QUERY } from "../../helpers/graphql/project";

interface ProjectFormValues {
  name: string;
  identifier: string;
}

export function CreateProject() {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const [createProject, { loading }] = useMutation(CREATE_PROJECT_MUTATION, {
    onCompleted: ({ createProject }) => {
      if (createProject) {
        message.success("Project created!");
        setIsModalVisible(false);
        navigate(projectSubgraphsPath(createProject.id));
      }
    },

    refetchQueries: () => [
      {
        query: PROJECTS_QUERY,
      },
    ],
  });

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
  };

  const handleSubmit = async (values: ProjectFormValues) => {
    createProject({ variables: values });
  };

  const handleValuesChange = async (changedValues: any) => {
    if (changedValues.name !== undefined) {
      form.setFieldsValue({ identifier: changedValues.name.replace(/\s+/g, "-").toLowerCase() });
    }

    if (changedValues.identifier !== undefined) {
      form.setFieldsValue({ identifier: changedValues.identifier.toLowerCase() });
    }
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        Create Project
      </Button>

      <Modal
        title="Create Project"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button onClick={handleCancel} key="back">
            Cancel
          </Button>,
          <Button
            form="createProjectForm"
            key="submit"
            htmlType="submit"
            type="primary"
            loading={loading}
          >
            Create
          </Button>,
        ]}
      >
        <Form<ProjectFormValues>
          id="createProjectForm"
          name="createProject"
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          onValuesChange={handleValuesChange}
          autoComplete="off"
        >
          <Form.Item name="name" label="Project Name" required>
            <Input />
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.identifier !== currentValues.identifier
            }
          >
            {({ getFieldValue }: any) => (
              <Form.Item
                name="identifier"
                label="Project Identifier"
                required
                extra={
                  <div style={{ marginTop: "5px" }}>
                    Subgraph names:{" "}
                    <Typography.Text code>
                      <strong>{getFieldValue("identifier")}</strong>/your-subgraph
                    </Typography.Text>
                  </div>
                }
              >
                <Input placeholder="Lowercase and hyphen only" />
              </Form.Item>
            )}
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
